export const getHyundaiShowRoomUrl = () => {
  const DEV_URL = 'https://showroom.familyagency.ru';
  const PROD_URL = 'https://showroom.hyundai.ru';
  const DevEnvironments = ['one-life-one-online.e-credit.one','stage-online.e-credit.one','localhost:3000'];

  return DevEnvironments.includes(window.location.host)
    ? DEV_URL
    : PROD_URL;
}
